import React from 'react';
import { EMAIL_VARIABLES } from '../../../../constants/EmailServicesConst';

const TextComponentBox = (props) => {
  const { componentObj, onClickComponent, componentNdx, isPreview } = props;

  const onComponentClick = () => {
    componentObj.index = componentNdx;
    componentObj.selected = true;
    onClickComponent(componentObj, componentNdx);
  };

  const setText = () => {
    if (!componentObj?.text) return '<p>Add Text Here<p>';
    let text = componentObj?.text.replaceAll('\n', '<br/>');
    if (componentObj?.hyperLink?.length > 0) {
      componentObj.hyperLink.forEach((link) => {
        text = text.replace(
          link.text,
          `<a href="${link.url}" target="_blank" style="color:${link.textColor}"> ${link.text} </a>`,
        );
      });
    }
    const currTextData = text.split('[');
    const getKeyword = currTextData.filter((keyVal) => keyVal.includes(']'));
    getKeyword.forEach((keyword) => {
      let inputKeyword = '';
      for (let i = 0; i < keyword.length; i++) {
        if (keyword[i] === ']') {
          if (keyword[i + 1]) {
            inputKeyword = keyword.slice(0, i + 1);
            break;
          } else {
            inputKeyword = keyword;
            break;
          }
        }
      }
      const isValidKey = EMAIL_VARIABLES.find((validKey) => validKey === inputKeyword);
      if (!isValidKey)
        text = text.replace(`[${inputKeyword}`, `<span style="color:red">[${inputKeyword}</span>`);
      else text = text;
    });
    return `<p>${text}</p>`;
  };

  return (
    <div className='my-2'>
      <div
        className={`card layout-card header-layout col-md-12 d-flex justify-content-center ${
          !isPreview && componentObj.selected ? 'layout-card-selected' : ''
        } 
         `}
        onClick={() => onComponentClick()}
        style={{
          backgroundColor: componentObj?.hexCode || '#82828214',
          fontSize: `${componentObj?.fontSize}px` || '15px',
          fontStyle:
            (componentObj?.fontStyle !== 'bold' && componentObj?.fontStyle === 'italic') ||
            componentObj?.italic
              ? 'italic'
              : 'normal',
          fontWeight: componentObj?.fontStyle === 'bold' || componentObj?.bold ? 'bold' : 'normal',
          color: componentObj?.textColor || 'black',
          padding: componentObj?.padding
            ? `${componentObj?.top}px ${componentObj?.right}px ${componentObj?.bottom}px ${componentObj?.left}px `
            : '10px',
          textAlign: componentObj?.alignment || 'center',
          overflow: 'auto',
          textDecoration: componentObj?.underline ? 'underline' : 'none',
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: setText() }}></div>
      </div>
    </div>
  );
};

export default TextComponentBox;
